import * as Yup from 'yup';

const startEndDaySchema = [
  {
    name: 'touchpos_eod_allowed_difference',
    initialValue: '',
    validation: Yup.number()
      .typeError('Amount must be a number')
      .positive('Amount must be greater than zero')
      .integer('Amount must be a whole number'),
    input: {
      placeholder: 'Amount',
      label: 'Allowed difference amount',
      className: 'touchpos_eod_allowed_difference',
      type: 'input',
    },
  },
  {
    name: 'touchpos_eod_disable_show_expected',
    initialValue: '',
    input: {
      className: 'touchpos_eod_disable_show_expected',
      label: 'Disable show expected amount',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_eod_disable_count_all_payment_types',
    initialValue: '',
    input: {
      className: 'touchpos_eod_disable_count_all_payment_types',
      label: 'Disable count all type payments',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_eod_reason_required',
    initialValue: '',
    input: {
      className: 'touchpos_eod_reason_required',
      label: 'Reason Required',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_get_short_report',
    initialValue: '',
    input: {
      className: 'touchpos_get_short_report',
      label: 'Get short X-report',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_get_report_only_last_shift',
    initialValue: '',
    input: {
      className: 'touchpos_get_report_only_last_shift',
      label: 'Get X-report only for last shift',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_disable_deposit_on_eod',
    initialValue: '',
    input: {
      className: 'touchpos_disable_deposit_on_eod',
      label: 'Do not use deposit on EOD',
      type: 'checkbox',
    },
  },
  {
    name: 'cash_inout_open_drawer',
    initialValue: '',
    input: {
      className: 'cash_inout_open_drawer',
      label: 'Open cash drawer on open/close day',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_remove_pending_sales_before_close_day',
    initialValue: '',
    input: {
      className: 'touchpos_remove_pending_sales_before_close_day',
      label: 'Remove pending sales on close day',
      type: 'checkbox',
    },
  },
  {
    name: 'pos_shifts_counted',
    initialValue: '',
    input: {
      className: 'pos_shifts_counted',
      label: 'Use drawer counting instead of default register counting',
      type: 'checkbox',
    },
  },
  {
    name: 'touchpos_eod_notes_required',
    initialValue: '',
    input: {
      className: 'touchpos_eod_notes_required',
      label: 'Notes required',
      type: 'checkbox',
    },
  },
];

export default startEndDaySchema;
